// Leaflet non è più importato staticamente: erano ~146 KB di JS più 11 KB di CSS
// scaricati, parsati ed eseguiti su OGNI pagina del sito, mentre la mappa esiste
// solo su tre view (sedi/map, sedi/map-big, promotions/map-promo — quella del
// footer è commentata da tempo in footer/sedi.blade.php).
//
// Le view che disegnano una mappa chiamano window.loadLeaflet() e ricevono L.

let leafletPromise = null;

window.loadLeaflet = function () {
    if (!leafletPromise) {
        leafletPromise = Promise.all([
            import('leaflet'),
            import('/node_modules/leaflet/dist/leaflet.css'),
        ]).then(([module]) => {
            const L = module.default ?? module;
            window.leaflet = L;
            // Il bundle UMD popola anche window.L, quindi il codice esistente
            // che usa la globale continua a funzionare senza modifiche.
            window.L = window.L || L;
            return window.L;
        });
    }
    return leafletPromise;
};
